import ApiRequest from "../utils/ApiRequest";

export default class Admins {

  login = async (admin) => {
    return await ApiRequest.set('/v1/admins/login', "POST", admin)
  }

  getAllAdmins = async () => {
    return await ApiRequest.set('/v1/admins', "GET")
  }

  create = async (admin) =>{
    return await ApiRequest.set("/v1/admins/create", "POST", admin)
  }

}
